import React, {Component} from 'react';
import PropTypes from 'prop-types';

function formatPrice(price) {
  return priceToFloat(price).toFixed(2).replace('.', ',');
}

export function priceToFloat(price) {
  let f = parseFloat(price);
  return isFinite(f) ? f : 0.0;
}

class RexSummary extends Component {
  static propTypes = {
    product: PropTypes.object,
    selectedGift: PropTypes.object,
    selectedDevice: PropTypes.object
  };

  render() {
    const { product, selectedGift, selectedDevice } = this.props;

    const products = [];

    if (product) {
      const price = priceToFloat(product.price);
      products.push({
        key: 'product',
        name: product.productName,
        price,
        period: 24,
        priceDescription: '24 kk määräaikainen sopimus, jonka jälkeen sopimus jatkuu toistaiseksi voimassa olevana. ' +
          'Kokonaishinta ' + formatPrice(24 * price) + ' €'
      });
    }

    if (selectedGift) {
      const gift = { ...selectedGift, key: 'gift' };
      if (gift.price && gift.freeDurationMonths) {
        gift.priceDescription = '' + gift.freeDurationMonths + ' kk määräaikainen sopimus, jonka jälkeen sopimus jatkuu toistaiseksi voimassa olevana hintaan ' + formatPrice(gift.price) + ' € / kk';
        gift.price = 0.0;
      }
      products.push(gift);
    }

    return (
      <div>
        <h3 className="ea-h3">Yhteenveto</h3>
        {
          products.map(item => (
            <div key={item.key} className="ea-fgrid">
              <div
                className="ea-fgrid__item ea-fgrid__item--phone-6 ea-fgrid__item--tablet-12 ea-fgrid__item--laptop-4 ea-pad ea-pad--pad-right-m ea-pad--pad-bottom-1">
                <h4 className="ea-h4">{item.name}</h4>
              </div>
              <div
                className="ea-fgrid__item ea-fgrid__item--phone-6 ea-fgrid__item--tablet-12 ea-fgrid__item--laptop-8 ea-pad ea-pad--pad-top-1 ea-pad--laptop-pad-top-0 ea-pad--pad-bottom-5">
                  <span className="ea-disclaimertext rx-disclaimer">
                    <div className="rx-price">{formatPrice(item.price)} € / kk</div>
                    <div>{item.priceDescription}</div>
                  </span>
              </div>
            </div>))
        }
        {
          selectedDevice && (
            <div key={selectedDevice.id} className="ea-fgrid">
              <div
                className="ea-fgrid__item ea-fgrid__item--phone-6 ea-fgrid__item--tablet-12 ea-fgrid__item--laptop-4 ea-pad ea-pad--pad-right-m ea-pad--pad-bottom-1">
                <h4 className="ea-h4">Lahja liitetään</h4>
              </div>
              <div
                className="ea-fgrid__item ea-fgrid__item--phone-6 ea-fgrid__item--tablet-12 ea-fgrid__item--laptop-8 ea-pad ea-pad--pad-top-1 ea-pad--laptop-pad-top-0 ea-pad--pad-bottom-5">
                <div className="rx-price">{selectedDevice.name}</div>
              </div>
            </div>
          )
        }
      </div>);
  }
}

export default RexSummary;



// WEBPACK FOOTER //
// ./web/js/components/rex/Summary.js